import React from 'react';
import PropTypes from 'prop-types';
import OrderWidget from 'components/OrderWidget';
import WidgetContainer from 'components/widget/WidgetContainer';
import PackPayments from 'components/PackPayments';
import ViewLayout from 'views/ViewLayout';
import JustMoved from 'components/JustMoved';
import AddressesPath from 'containers/paths/AddressesContainerPath';

const OrderView = ({
  className, pack, canChangeAddress, showJustMoved,
}) => {
  const classes = ['OrderView', className];

  return (
    <ViewLayout className={classes.filter((c) => !!c).join(' ')}>
      <OrderWidget
        pack={pack}
        canChangeAddress={canChangeAddress}
      />
      {pack.status === 'Cancelled' && (
        <WidgetContainer>
          <h4>Your payments</h4>
          <p>
            Any payments made towards this delivery will remain on your account
            and be used before we collect further funds from your nominated
            payment method.
          </p>
        </WidgetContainer>
      )}
      {showJustMoved && <JustMoved path={AddressesPath({}, 'changeDefault')} />}
      <WidgetContainer>
        <h4>Payments for this delivery</h4>
        <PackPayments packStatus={pack.status} payments={pack.payments} />
      </WidgetContainer>
    </ViewLayout>
  );
};

OrderView.displayName = 'OrderView';

OrderView.propTypes = {
  className: PropTypes.string,
  canChangeAddress: PropTypes.bool,
  pack: PropTypes.shape({
    status: PropTypes.string.isRequired,
    payments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
  showJustMoved: PropTypes.bool,
};

OrderView.defaultProps = {
  className: null,
  canChangeAddress: false,
  showJustMoved: false,
};

export default OrderView;
